import { configureStore } from '@reduxjs/toolkit';
import { /* Provider, */ useDispatch as useAppDispatch, useSelector as useAppSelector } from 'react-redux';
import { persistStore } from 'redux-persist';
import { rootReducer } from './root-reducer';

// ----------------------------------------------------------------------

/*
export const AppWrapper = () => {
  const store = configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        serializableCheck: false,
        immutableCheck: false,
      }),
  });
  return (
    // eslint-disable-next-line react/jsx-filename-extension
    <Provider store={store}>
      <div />
    </Provider>
  );
};
*/

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
      immutableCheck: false,
    })
})

export const persistor = persistStore(store, {}, () => {
  console.log('Rehydration complete');
})

// Add timeout error handling
persistor.subscribe(() => {
  const { bootstrapped } = persistor.getState();
  if (bootstrapped) {
    console.log('Redux-persist bootstrapped successfully');
  }
})

export const useSelector = useAppSelector

export type RootState = ReturnType<typeof store.getState>

export type AppDispatch = typeof store.dispatch

export const useDispatch = useAppDispatch.withTypes<AppDispatch>()
